/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {Form} from 'react-bootstrap'
import {formErrorEnum} from './data'


export default function FieldUsername(props) {
    function checkUsername(v) {
        // write to state
        props.setFormInfo({...props.formInfo, username: v})

        // check
        if (v === ""){
            props.setFormState({...props.ormState, username: formErrorEnum.usernameEmpty})
        } else {
            props.setFormState({...props.formState, username: ""})
        }
    }

    return (
        <div>
            <Form.Control 
                type="text" 
                placeholder="Username" 
                value={props.formInfo.username}
                onChange={(e) => checkUsername(e.target.value)}
            />
            {
                props.formState.username !== "" &&
                <Form.Text className="text-red text-left" style={{color: "red"}}>
                    {props.formState.username}
                </Form.Text>
            }
            <br/>
        </div>
    )
}
